export default "__VITE_PUBLIC_ASSET__2f6b78df__"